import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import brandlogo from "../assets/img/logo/ji-impex.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPhoneAlt, faEnvelopeOpen, faClock } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faWhatsapp, faLinkedinIn, faInstagram } from "@fortawesome/free-brands-svg-icons";

const Mobilenavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isSticky, setIsSticky] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [openSubcategory, setOpenSubcategory] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
      setShowSearch(false); // Search submit thay pachhi field close kari devu
    }
  };

  useEffect(() => {
    fetch("https://jiimpex.com/new_project/ji-impex/get-categories.php")
      .then((response) => response.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));

    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    const handleScroll = () => setIsSticky(window.scrollY > 100);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMobileMenu = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
      setOpenCategory(null);
      setOpenSubcategory(null);
    }
  };

  return (
    <>
      <nav className={`navbar navbar-expand-lg bg-white navbar-light sticky-top ${isSticky ? "sticky-navbar" : ""}`}>
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={brandlogo} alt="Ji Impex" className="img-fluid company-logo" />
          </Link>
          <div className="toggle-search">
            {/* Search Icon and Search Field */}
            <div className="search-container">
              {showSearch && <div className="search-overlay" onClick={() => setShowSearch(false)}></div>}
              {!showSearch && (
                <FontAwesomeIcon icon={faSearch} className="search-icon" onClick={() => setShowSearch(!showSearch)} />
              )}
              <div className={`search-input-container ${showSearch ? "show" : ""}`}>
                {showSearch && (
                  <form onSubmit={handleSearch} className="search-form">
                    <input
                      type="text"
                      placeholder="Search Products..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button type="submit">Search</button>
                  </form>
                )}
              </div>
            </div>
            <button className="navbar-toggler" type="button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>
          <div className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`}>
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} to="/" onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about" onClick={closeMobileMenu}>
                  About Us
                </Link>
              </li>
              {categories.map((category) => (
                <li
                  key={category.id}
                  className="nav-item dropdown position-relative"
                  onMouseEnter={!isMobile ? () => setOpenCategory(category.id) : null}
                  onMouseLeave={!isMobile ? () => setOpenCategory(null) : null}
                >
                  <span
                    className={`nav-link dropdown-toggle ${openCategory === category.id ? "active" : ""}`}
                    onClick={isMobile ? () => setOpenCategory(openCategory === category.id ? null : category.id) : null}
                  >
                    {category.name}
                  </span>

                  {openCategory === category.id && (
                    <div className={`dropdown-menu ${isMobile ? "d-block" : "position-absolute bg-light"}`}>
                      {category.subcategories.map((sub) => (
                        <div
                          key={sub.id}
                          className="position-relative"
                          onMouseEnter={!isMobile ? () => setOpenSubcategory(sub.id) : null}
                          onMouseLeave={!isMobile ? () => setOpenSubcategory(null) : null}
                        >
                          <span
                            className="dropdown-item d-flex justify-content-between align-items-center zk-sub"
                            onClick={isMobile ? () => setOpenSubcategory(openSubcategory === sub.id ? null : sub.id) : null}
                          >
                            {sub.subcategories.length > 0 ? (
                              <span>{sub.name}</span> // If subcategory has children, just show text
                            ) : (
                              <Link key={sub.id} to={`/products/${sub.id}`} className="dropdown-item" onClick={closeMobileMenu}>
                                {sub.name}
                              </Link>
                            )}
                            {sub.subcategories.length > 0 && <span className="ms-auto">{isMobile ? "▾" : "▸"}</span>}
                            {/* <Link key={sub.id} to={`/products/${sub.id}`} className="dropdown-item" onClick={closeMobileMenu}>
                              {sub.name}
                              {sub.subcategories.length > 0 && (
                                <span className="ms-auto">{isMobile ? "▾" : "▸"}</span>
                              )}
                            </Link> */}
                          </span>

                          {openSubcategory === sub.id && (
                            <div className={`dropdown-menu1 ${isMobile ? "d-block" : "position-absolute bg-light"} zk-child`} style={{ left: "100%", top: "0" }}>
                              {sub.subcategories.map((child) => (
                                <Link key={child.id} to={`/products/${child.id}`} className="dropdown-item" onClick={closeMobileMenu}>
                                  {child.name}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </li>
              ))}
              <li className="nav-item">
                <Link className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} to="/contact" onClick={closeMobileMenu}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Mobilenavbar;
